module.exports = __webpack_public_path__ + "img/curv_18_b.36dd67b6.jpg";